import LoggedOutIcon from 'src/assets/svg/logged-out-icon';
import { useDeviceType } from 'src/hooks/useDeviceType';
import LoginLayout from 'src/modules/layout/login-layout';
import AccessDenied from 'src/modules/login/access-denied';

const LoggedOutContainer = () => {
	const deviceType = useDeviceType();

	return (
		<LoginLayout>
			<AccessDenied
				icon={<LoggedOutIcon />}
				headerText={<>Log Out Successful</>}
				infoText={
					<>
						You’ve been successfully logged out.
						{deviceType === 'desktop' ? <br /> : ' '}
						To log back in, please use the access link in your email.
					</>
				}
			/>
		</LoginLayout>
	);
};

export default LoggedOutContainer;
